import utils from '@/util'

/* eslint-disable import/prefer-default-export */
export const isFocusingOnAnInput = () => {
  return document.activeElement &&
        (document.activeElement.nodeName === 'INPUT' ||
        document.activeElement.nodeName === 'TEXTAREA')
}

export const hasCommandModifier = (event) => Boolean(event.ctrlKey || event.metaKey || event.altKey)

const isFocusingOnContentEditable = () => Boolean(document.activeElement && document.activeElement.isContentEditable)

export const isFocusingOnEditableField = () => isFocusingOnAnInput() || isFocusingOnContentEditable()

export const isBareHotkey = (event, keyCode) => event.keyCode === keyCode &&
  !event.repeat &&
  !hasCommandModifier(event) &&
  !isFocusingOnEditableField()

export const isElementInViewport = (el) => {
  const rect = el.getBoundingClientRect()
  return (
    rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  )
}
export function deleteFakeDom() {
  const doms = document.querySelectorAll('.fake-selection')
  if (doms.length > 0) {
    Array.from(doms).forEach((fakeSelection) => {
      fakeSelection.outerHTML = fakeSelection.innerHTML
    })
  }
}

export function restoreOriginalLinks() {
  const doms = document.querySelectorAll('.fake-selection')
  if (doms.length > 0) {
    Array.from(doms).forEach((fakeSelection) => {
      const originalLinkHtml = fakeSelection.getAttribute('data-original-link-html')
      if (originalLinkHtml) {
        // Restore the original link
        fakeSelection.outerHTML = originalLinkHtml
      } else {
        // No original link, just remove the fake selection wrapper
        fakeSelection.outerHTML = fakeSelection.innerHTML
      }
    })
  }
}

export const isSafariOriOS = () => {
  // FIXME: Consider removing this as there should be any reason
  // why we need a specific class for safari.
  // This was added by Loi to fix an issue with safari but we lost track of the original issue.
  // @huongnguyen2152 15.05.2020
  // eslint-disable-next-line
    let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
  const ua = window.navigator.userAgent
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
  const webkit = !!ua.match(/WebKit/i)
  const iOSSafari = iOS && webkit && !ua.match(/CriOS/i)
  return isSafari || iOSSafari
}

export const detectSafari = () => {
  try {
    if (isSafariOriOS()) {
      document.body.classList.add('safari-browser')
    }
  } catch (error) {
    // do nothing
  }
}

export const isIOS = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  // Check for iOS
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
}

export const scrollToActiveSlide = async () => {
  const leftScrollBarDOM = document.getElementById('leftScrollBar')
  if (!leftScrollBarDOM) return

  const activeSlideDOM = document.getElementsByClassName('active-slide')?.[0]
  if (!activeSlideDOM) return

  await utils.sleep(200)
  utils.scrollToElement(leftScrollBarDOM, {
    behavior: 'smooth',
    top: activeSlideDOM.offsetTop - 200,
  })
}
